import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo, GoldButton, Input } from "@/components/ui-kit";

export default function VerifyEmail() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  const verify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/verify-email", { code });
      setUser({ ...user, email_verified: true });
      toast.success("Email verified. Welcome to the family!");
      navigate(user?.onboarding_completed ? "/portal" : "/onboarding");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    setResending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("New code sent!");
    } catch {
      toast.error("Could not resend code");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#060D1F] flex flex-col" data-testid="verify-email-page">
      <div className="px-5 sm:px-8 pt-6"><Logo /></div>
      <main className="flex-1 flex items-center justify-center px-5 py-14">
        <div className="w-full max-w-md fade-up">
          <h1 className="text-3xl sm:text-4xl text-white tracking-tight">Check your inbox</h1>
          <p className="mt-3 text-slate-400">We sent a 6-digit code to <span className="text-[#D4AF37]">{user?.email}</span></p>
          <form onSubmit={verify} className="mt-9 space-y-5" data-testid="verify-form">
            <Input data-testid="verify-code-input" label="Verification code" placeholder="123456" value={code} onChange={(e) => setCode(e.target.value)} required />
            <GoldButton data-testid="verify-submit-button" type="submit" disabled={loading} className="w-full">{loading ? "Verifying..." : "Verify email"}</GoldButton>
          </form>
          <button data-testid="resend-code-button" onClick={resend} disabled={resending} className="mt-6 text-sm text-slate-400 transition-colors duration-300 hover:text-[#D4AF37]">
            {resending ? "Sending..." : "Didn't get it? Resend code"}
          </button>
        </div>
      </main>
    </div>
  );
}
